var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12,
    viewBox: "0 0 16 12"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0-2h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill",
    d: "M15.907 1.542a.738.738 0 00-.051.033L8 6.341.144 1.575a.738.738 0 00-.051-.033A2.186 2.186 0 012.182 0h11.636c.983 0 1.818.652 2.09 1.542zM16 3.18v6.653C16 11.027 15.02 12 13.818 12H2.182A2.179 2.179 0 010 9.833V3.18l7.583 4.634c.25.174.584.174.834 0L16 3.18z"
  }))));
}
export default SvgMail;